/**
 * @file
 * Share block (print / social sharing) behaviors for layerone.
 */
(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.layeroneShare = {
    attach: function (context, settings) {

      $('.share-block .print-button').on('click', function (e) {
        e.preventDefault();
        window.print();
      });
      $('.share-block .share-button').on('click', function (e) {
        e.preventDefault();
        const expanded = $(this).attr('aria-expanded') === 'true';
        $(this).next('div').slideToggle('1000');
        $(this).attr('aria-expanded', !expanded);
      });
      // This page on this site, encoded to go inside another URL's query.
      const currentUrl = encodeURIComponent(
        `${window.location.origin}${window.location.pathname}`,
      );
      const pageTitle = encodeURIComponent(document.title);
      $('.share-block__list-items .share-facebook').on('click', function (e) {
        e.preventDefault();
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`);
      });
      $('.share-block__list-items .share-x').on('click', function (e) {
        e.preventDefault();
        window.open(
          `https://twitter.com/intent/tweet?url=${currentUrl}`,
        );
      });
      $('.share-block__list-items .share-linkedin').on('click', function (e) {
        e.preventDefault();
        window.open(
          `https://www.linkedin.com/sharing/share-offsite/?url=${currentUrl}`,
        );
      });
      $('.share-block__list-items .share-email').on('click', function (e) {
        e.preventDefault();
        window.open(
          `mailto:?subject=${pageTitle}&body=${currentUrl}`,
        );
      });

    }
  };

})(jQuery, Drupal);
